import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalInputManager {
  private _onEvent = new EventEmitter<any>();
  private _startTime!: number;

  /**
   * Event type 'event', 'changedeviceusage'
   * @return {EventEmitter<any>}
   */
  get onEvent() {
    return this._onEvent;
  }

  /**
   * @return {Array<any>}
   */
  get devices(): Array<any> {
    throw new Error('Please implement this method.');
  }

  /**
   * @return {number} time (sec)
   */
  get startTime(): number {
    return this._startTime;
  }

  /**
   * @return {number} time (sec)
   */
  get timeSinceStartup(): number {
    return Date.now() / 1000 - this._startTime;
  }

  /**
   * @param {number} time (sec)
   */
  setStartTime(time: number) {
    this._startTime = time;
  }
}
